import { BOX_BOTTOM_SPACING, FIRST_ROW_OFFSET, LAST_ROW_OFFSET } from '../constants';

type Config = {
  isFirst?: boolean;
  isLast?: boolean;
};

export default function getRowHeight(boxHeight: number, config: Config = {}): number {
  let rowHeight = boxHeight + BOX_BOTTOM_SPACING;
  if (config.isFirst) {
    rowHeight = rowHeight + FIRST_ROW_OFFSET;
  }

  if (config.isLast) {
    rowHeight = rowHeight + LAST_ROW_OFFSET;
  }

  return rowHeight;
}
